export default __webpack_public_path__ + "static/media/google-calendar-icon.5fee35fd.png";